// app/providers.tsx
"use client";

import dynamic from "next/dynamic";

const CommandMenuProvider = dynamic(
  () =>
    import("@/components/command-menu/command-menu-provider").then(
      (mod) => mod.CommandMenuProvider,
    ),
  { ssr: false },
);

export function Providers({ children }: { children: React.ReactNode }) {
  return <CommandMenuProvider>{children}</CommandMenuProvider>;
}
